// extracted by extract-css-chunks-webpack-plugin
module.exports = {"nav":"nav_1xh-u","next":"next_1lFsP","prev":"prev_1HnCp"};